import { useAnchorClickMessageDispatcher } from '@carvana/merch-native';
import { isNonProd } from '~/constants/environment';
import useUpdateGeolocationDispatcher from '~/native/common/dispatchers/useUpdateGeolocationDispatcher';
import { logError } from '~/utilities/loggers';
import {
  useFullscreenDispatcher,
  useIsFavoriteDispatcher,
  useModalMessageDispatcher,
  usePageReadyDispatcher,
  useToggleChatDispatcher,
  useTradeInAppliedDispatcher
} from './dispatchers';
import { source } from './dispatchers/constants';

/**
 * This hook dispatches messages to the native app.
 */

export default function useNativeMessageDispatcher() {
  useAnchorClickMessageDispatcher({
    logError,
    source,
    verboseLogs: isNonProd
  });
  useFullscreenDispatcher();
  useIsFavoriteDispatcher();
  useModalMessageDispatcher();
  usePageReadyDispatcher();
  useToggleChatDispatcher();
  useTradeInAppliedDispatcher();
  useUpdateGeolocationDispatcher();
}
